import type { Json } from '@/types/database.generated';

export type AppointmentEmailReminderSettings = {
  enabled: boolean;
  leadHours: number;
};

export function readAppointmentEmailReminderSettings(
  raw: Json | null | undefined,
): AppointmentEmailReminderSettings {
  const o =
    raw && typeof raw === 'object' && !Array.isArray(raw)
      ? (raw as Record<string, Json>)
      : {};
  const leadRaw = o.appointment_reminder_lead_hours;
  const lead = typeof leadRaw === 'number' ? leadRaw : Number(leadRaw);
  return {
    enabled: o.appointment_reminders_enabled !== false,
    leadHours: Number.isFinite(lead) && lead >= 1 && lead <= 168 ? Math.round(lead) : 24,
  };
}

export function mergeAppointmentEmailReminderSettings(
  existing: Json | null | undefined,
  next: AppointmentEmailReminderSettings,
): Record<string, Json> {
  const base =
    existing && typeof existing === 'object' && !Array.isArray(existing)
      ? { ...(existing as Record<string, Json>) }
      : {};
  return {
    ...base,
    appointment_reminders_enabled: next.enabled,
    appointment_reminder_lead_hours: next.leadHours,
  };
}
